/**
 * Domain errors carry a stable machine-readable code. The API layer maps them to
 * HTTP status codes and the uniform error envelope (spec §7.1).
 */
export type DomainErrorCode =
  | 'VALIDATION_FAILED'
  | 'NOT_FOUND'
  | 'FORBIDDEN'
  | 'UNAUTHENTICATED'
  | 'CONFLICT'
  | 'VERSION_CONFLICT'
  | 'INVARIANT_VIOLATION'
  | 'MONEY_OVERFLOW'
  | 'CURRENCY_MISMATCH'
  | 'INSUFFICIENT_STOCK';

export class DomainError extends Error {
  readonly code: DomainErrorCode;
  readonly details: Record<string, unknown>;

  constructor(code: DomainErrorCode, message: string, details: Record<string, unknown> = {}) {
    super(message);
    this.name = 'DomainError';
    this.code = code;
    this.details = details;
  }
}

export function invariant(condition: unknown, message: string): asserts condition {
  if (!condition) throw new DomainError('INVARIANT_VIOLATION', message);
}
